<mat-card class="cardWithShadow">
  <mat-card-header class="padding-horizonatal-sm no-padding-vertical">
    <div class="row w-100">
      <div class="col-12 text-center d-flex align-items-center gap-spacer flex-wrap">
        <div class="d-flex align-items-center flex-wrap">
          <mat-button-toggle-group [formControl]="selectedShape">
            <mat-button-toggle class="position-relative" value="{{shapeDraw.POINTER}}" [matTooltip]="'filemanager.draw.pointer' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="pointer" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.SCRIBBLE}}" [matTooltip]="'filemanager.draw.free_hand' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="scribble" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.RECTANGLE}}" [matTooltip]="'filemanager.draw.rectangle' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="rectangle" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.CIRCLE}}" [matTooltip]="'filemanager.draw.circle' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="circle" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.ARROW}}" [matTooltip]="'filemanager.draw.arrow' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="arrow-right" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.LINE}}"  [matTooltip]="'filemanager.draw.line' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="line" class="icon-24"></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.TEXT}}" [matTooltip]="'filemanager.draw.text' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="text-resize" class="icon-24" ></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.START_CROP}}" [matTooltip]="'filemanager.draw.crop' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="crop" class="icon-24" ></i-tabler>
            </mat-button-toggle>
            <mat-button-toggle class="position-relative" value="{{shapeDraw.STOP_CROP}}" [disabled]="selectedShape.value !== shapeDraw.START_CROP"  [matTooltip]="'filemanager.draw.crop_end' | translate" matTooltipPosition="above" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
              <i-tabler name="frame-off" class="icon-24"></i-tabler>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
         <div class="button-container">
            <div class="form-control d-flex flex-col text-left">
              <label class="label-thickenss"><small>{{ 'filemanager.draw.thickness' | translate }}</small></label>
              <mat-slider  [disabled]="disabled" [max]="max" [min]="min"
                [step]="step" [matTooltip]="'filemanager.draw.thickness_tooltip' | translate" matTooltipPosition="above" [discrete]="thumbLabel" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip"
                [showTickMarks]="showTicks" id="size-slider" (input)="onSizeChange($event)">
                <input matSliderThumb [formControl]="sizeValue" />
              </mat-slider>
            </div>
          </div>
        <!-- <div class="divider"></div> -->
         <div class="button-container">
            <mat-form-field appearance="outline" [style]="{'width': '120px'}" subscriptSizing="dynamic">
              <mat-label>{{ 'filemanager.draw.font_size' | translate }}</mat-label>
              <mat-select [formControl]="sizeFontValue" (selectionChange)="onChangeFontSize($event)">
                <mat-option *ngFor="let option of optionsSizeValue" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        <!-- <div class="divider"></div> -->
         <div class="button-container">
        <mat-button-toggle-group hideSingleSelectionIndicator>
          <mat-button-toggle class="position-relative " [style.background-color]="selectedColor" [matTooltip]="'filemanager.draw.pick_color' | translate" matTooltipPosition="above" (click)="showColorPicker()" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
            <i-tabler name="palette" class="icon-24" [style]="{'color': contrastColor}"></i-tabler>

          </mat-button-toggle>
          <mat-button-toggle class="position-relative bg-light-primary"  [matTooltip]="'filemanager.draw.download_image' | translate" matTooltipPosition="above" (click)="downloadImage()" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
            <i-tabler name="download" class="icon-24"></i-tabler>
          </mat-button-toggle>
          <mat-button-toggle class="position-relative bg-error text-white" [matTooltip]="'filemanager.draw.clear_canvas' | translate" matTooltipPosition="above" (click)="removeObjectCanvas()" (mouseleave)="destroyTooltip($event)" #tooltip="matTooltip">
            <i-tabler name="trash" class="icon-24"></i-tabler>
          </mat-button-toggle>
        </mat-button-toggle-group>
         @if (isVisibleColorPicker) {
            <div class="picker">
              <chrome-picker [control]="colorControl">
                <div class="buttons">
                  <button mat-stroked-button (click)="applyClick($event)">{{ 'filemanager.draw.apply' | translate }}</button>
                </div>
              </chrome-picker>
              <div class="overlay" (click)="discardClick($event)"></div>
            </div>
            }
        </div>
        <div class="button-container">
          <button mat-flat-button class="bg-primary text-white" (click)="save()">
            <i-tabler name="send" class="icon-20 mdi-format-vertical-align-center"
              style="vertical-align: middle"></i-tabler>
            {{ (isEditMode ? 'filemanager.draw.save' : 'filemanager.draw.send') | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="no-padding p-0">
    <div class="d-block w-100 bg-light p-y-16  overflow-content" #canvascontainer>
        <canvas #canvas height="500" width="800" style="border:1px solid #000; margin:auto"></canvas>
    </div>
  </mat-card-content>
</mat-card>